module.exports = __webpack_public_path__ + "img/menulingua_logo_final.3abc3e4b.svg";